// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../admin/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.router-link-exact-active[data-v-a0f11eec] {\n    color: #485fc7;\n    border-bottom: 2px solid #485fc7;\n}\n\n", ""]);
// Exports
module.exports = exports;
